// -- import * as _ from "lodash-es"
import * as api from "../../shared/api"
import apiPath from "../../shared/apiPath"
import * as biz_data_helper from "../../shared/biz_data_helper"

const content_type = ""

const create = function () {
  return {
    content_type: "muji",
    age: 29
  }
}
const fields = [
  {
    key: "id", label: "编号", sortable: true, type: "button", thStyle: { width: "60px" }, button: { type: "text" },
  },
  {
    key: "username",
    label: "用户名",
    sortable: true
  },
  {
    key: "realname",
    label: "姓名",
    sortable: true
  },
  {
    key: "email",
    label: "邮箱",
    sortable: true,
    thStyle: { width: "12rem" }
  },
  {
    key: "department",
    label: "部门",
    sortable: true
  },
  {
    key: "description",
    label: "备注",
    sortable: true
  },
  {
    key: "language_code",
    label: "语言"
  },
  {
    key: "is_valid",
    label: "启用",
    type: "boolean"
  },
  {
    key: "isInternal",
    label: "内部账号",
    type: "boolean"
  },
  {
    key: "isDomainUser",
    label: "域用户",
    type: "boolean"
  },
  {
    key: "is_Include_All",
    label: "绑定所有客户",
    type: "boolean"
  },
  {
    key: "last_access_time", label: '最后访问时间', sortable: true, type: "datetime"
  }
  // {
  //   key: "changePWD",
  //   label: "",
  //   type: "button",
  //   thStyle: { width: "4rem" },
  //   button: {
  //     type: "text",
  //     class: "cell_button",
  //     label: "重置密码",
  //     icon_class: "fa fa-refresh"
  //   },
  // },
]
const export_fields = [{
  key: "username",
  label: "用户名",
},
{
  key: "realname",
  label: "姓名",
},
{
  key: "email",
  label: "邮箱",
  width: "80px"
},
{
  key: "department",
  label: "部门",
},
{
  key: "description",
  label: "用户说明",
},
{
  key: "user_is_valid",
  label: "用户启用状态",
},
{
  key: "code",
  label: "权限编码",
},
{
  key: "name",
  label: "权限名称",
},
{
  key: "category",
  label: "权限分类",
},
{
  key: "description",
  label: "权限说明",
},
{
  key: "is_valid",
  label: "权限启用状态",
  type: "boolean"
},
]

const dataForm = {
  id: "",
  username: "",
  realname: "",
  email: "",
  department: "",
  password: "abcd123",
  repassword: "abcd123",
  description: "",
  is_valid: true,
  isInternal: false,
  isDomainUser: true,
  is_Include_All: false
}
const dataPwdForm = {
  id: "",
  password: "",
}


///前端验证
const rules = {
  username: [{
    required: true,
    message: "请输入用户名",
    trigger: "blur"
  },],
  // password: [{
  //   required: true,
  //   message: "请输入密码",
  //   trigger: "blur"
  // }],
}
const pwdrules = {
  // password: [{
  //   required: true,
  //   message: "请输入密码",
  //   trigger: "blur"
  // }],
}

const descriptor = {
  name: {
    type: "string",
    required: true,
    validator: (rule, value) => value === "muji"
  },
  age: {
    type: "number",
    asyncValidator: (rule, value) => {
      return new Promise((resolve, reject) => {
        api
          .request({
            url: biz_data_helper.get_endpoint("test_fetch").url,
            parameters: {
              c: "a666"
            }
          })
          .then(res => {


            if (value == res.data[0].echo) {
              resolve(res)
            } else {
              reject("测试没通过")
            }
          })
          .catch(err => {
            reject(err)
          })
      })
    }
  }
}

const methods = {
  async insertDefaultRole(userId) {
    const code_biz_data = new biz_data_helper.base_entity_helper(
      "insert_default_role", {}, {}
    )
    let result = await code_biz_data
      .execAction({
        params: {
          userId: userId
        },
        fields: ["id"]
      })
      .run()

    if (
      result &&
      result[0].result &&
      result[0].result.data &&
      result[0].result.data.ActionResult &&
      result[0].result.data.ActionResult.Result &&
      result[0].result.data.ActionResult.Result.Data.length > 0
    ) {
      return result[0].result.data.ActionResult.Result.Data[0][0]
    } else {
      return null
    }
  },
  async deleteUser(ids) {
    let _actions = []

    let delete_biz_data = new biz_data_helper.base_entity_helper(
      "delete_sUser", {}, {}
    )
    _.each(ids, t => {
      _actions.push(
        delete_biz_data
          .execAction({
            params: {
              id: t,
            }
          })
          .action({})
      )
    })

    let result = await api.query_batch({
      actions: _actions
    })
    if (
      result &&
      result.data &&
      result.data.BatchResult &&
      result.data.BatchResult.Actions &&
      result.data.BatchResult.Actions.length > 0
    ) {
      return result.data.BatchResult.Actions
    } else {
      return null
    }
  },
  ///get
  async getData() {
    let result = await api.query_async({
      url: apiPath.admin.get_user_list,
      parameters: null,
      method: "get"
    })

    ///此处可以编写逻辑处理
    if (
      result &&
      result[0].result.data &&
      result[0].result.data.Result.length > 0
    ) {
      return result[0].result.data.Result
    } else {
      return null
    }
  },
  ///获取用户语言
  async getUserLanguage() {
    const code_biz_data = new biz_data_helper.base_entity_helper("get_users", {}, {})
    let _fields = ["id", "language_code"]
    let result = await code_biz_data
      .execAction({
        params: {},
        fields: _fields
      }).run()
    if (
      result &&
      result[0].result &&
      result[0].result.data &&
      result[0].result.data.ActionResult &&
      result[0].result.data.ActionResult.Result &&
      result[0].result.data.ActionResult.Result.Data.length > 0
    ) {
      return result[0].result.data.ActionResult.Result.Data
    } else {
      return null
    }
  },
  ///获取用户待处理列表
  async getUserMessageList(userId) {
    const code_biz_data = new biz_data_helper.base_entity_helper("get_user_approve_status_list", {}, {})
    let result = await code_biz_data
      .execAction({
        params: { UserId: userId },
        fields: []
      }).run()
    if (
      result &&
      result[0].result &&
      result[0].result.data &&
      result[0].result.data.ActionResult &&
      result[0].result.data.ActionResult.Result &&
      result[0].result.data.ActionResult.Result.Data.length > 0
    ) {
      return result[0].result.data.ActionResult.Result.Data
    } else {
      return null
    }
  },
  ///更新语言
  async updateUserLang(items) {
    let _actions = []
    let biz_data = new biz_data_helper.base_entity_helper(
      "update_user_info",
      {},
      {}
    )
    _.each(items, (t) => {
      _actions.push(
        biz_data.execAction({
          params: { userId: t.id, language_code: t.language_code },
          fields: ["id"]
        }).action({})
      )
    })

    let result = await api.query_batch({
      actions: _actions
    })

    if (
      result &&
      result.data &&
      result.data.BatchResult &&
      result.data.BatchResult.Actions &&
      result.data.BatchResult.Actions.length > 0
    ) {
      return true

    } else {
      return null
    }
  },
  // resetPwd
  async resetPwd(data) {
    let _p = new FormData()
    _p.append("id", data.id)
    _p.append("newPwd", data.password)
    let result = await api.query_async({
      url: apiPath.admin.reset_pwd,
      parameters: _p,
      method: "post"
    })
    if (
      result &&
      result[0].result.data
    ) {
      return result[0].result.data.Result
    } else {
      return null
    }
  },
  ///save user
  async saveData(data) {
    let _p = new FormData()

    _p.append("id", data.id)
    _p.append("username", data.username)
    _p.append("password", data.password)
    _p.append("realname", data.realname == null ? "" : data.realname)
    _p.append("email", data.email == null ? "" : data.email)
    _p.append("department", data.department == null ? "" : data.department)
    _p.append("description", data.description == null ? "" : data.description)
    _p.append("is_valid", data.is_valid)
    _p.append("isDomainUser", data.isDomainUser)
    _p.append("isInternal", data.isInternal)
    _p.append("is_Include_All", data.is_Include_All)

    if (data.id == "") {
      delete _p.id
      _p.append("is_deleted", 0)
      let result = await api.query_async({
        url: apiPath.admin.add_user,
        parameters: _p,
        method: "post"
      })
      if (
        result &&
        result[0].result.data
      ) {
        return result[0].result.data.Result
      } else {
        return null
      }
    } else {

      _p.delete("password")

      let result = await api.query_async({
        url: apiPath.admin.update_user,
        parameters: _p,
        method: "post"
      })
      if (
        result &&
        result[0].result.data
      ) {
        return result[0].result.data.Result
      } else {
        return null
      }
    }
  },
  ///get userRoles
  async getUserRoles(userId) {
    let result = await api.query_async({
      url: apiPath.admin.get_user_roles_list + userId,
      parameters: null,
      method: "get"
    })
    ///此处可以编写逻辑处理
    if (
      result &&
      result[0].result.data &&
      result[0].result.data.Result.length > 0
    ) {
      return result[0].result.data.Result
    } else {
      return null
    }
  },
  ///get userPrivilege
  async getUserPrivilege(secpUserId) {
    let result = await api.query_async({
      url: apiPath.admin.get_user_privilege_list + secpUserId,
      parameters: null,
      method: "get"
    })
    ///此处可以编写逻辑处理
    if (
      result &&
      result[0].result &&
      result[0].result.data &&
      result[0].result.data.Result &&
      result[0].result.data.Result.length > 0
    ) {
      return result[0].result.data.Result
    } else {
      return null
    }
  },
  ///block users
  async blockUsers(userIds) {
    console.log(userIds)
    let query_settings = []
    _.each(userIds, t => {
      let _p = new FormData()
      _p.append("specUserId", t)
      query_settings.push({
        url: apiPath.admin.block_user,
        parameters: _p,
        method: "post"
      })
    })

    let result = await api.query_all_async(query_settings)
    if (result && result[0].result && result[0].result.data) {
      return result[0].result.data
    } else {
      return null
    }
  },
  ///active users
  async activeUsers(userIds) {
    console.log(userIds)
    let query_settings = []
    _.each(userIds, t => {
      let _p = new FormData()
      _p.append("specUserId", t)
      query_settings.push({
        url: apiPath.admin.active_user,
        parameters: _p,
        method: "post"
      })
    })

    let result = await api.query_all_async(query_settings)
    if (result && result[0].result && result[0].result.data) {
      return result[0].result.data
    } else {
      return null
    }
  },
  ///add  user roles
  async updateUserRoles(add_items, remove_items, userId) {
    let query_settings = []
    if (add_items.length > 0) {
      _.each(add_items, function (t) {
        let _p = new FormData()
        _p.append("roleId", t.id)
        _p.append("specUserId", userId)
        query_settings.push({
          url: apiPath.admin.add_role_user,
          parameters: _p,
          method: "post"
        })
      })
    }
    if (remove_items.length > 0) {
      _.each(remove_items, function (t) {
        let _p = new FormData()
        _p.append("roleId", t.id)
        _p.append("specUserId", userId)
        query_settings.push({
          url: apiPath.admin.remove_role_user,
          parameters: _p,
          method: "post"
        })
      })
    }
    if (query_settings.length > 0) {
      let result = await api.query_all_async(query_settings)
      if (result && result[0].result && result[0].result.data) {
        return result[0].result.data
      } else {
        return null
      }
    }
  }
}

const biz_data = new biz_data_helper.base_entity_helper(
  content_type,
  create,
  descriptor
)
export {
  biz_data, dataForm,
  dataPwdForm, export_fields, fields, methods, pwdrules, rules
};

